import { Button, Typography, Grid } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import HistoricItems from './components/HistoricItems'
import HistoricForm from '../../HistoricForm'
import { withTranslation } from 'react-i18next'

import '../../styles.css'

function TabPanelHistoricContent({
  classes,
  TabPanel,
  selectedTab,
  isHistorySelected,
  setHistorySelected,
  historySelected,
  archives,
  isHistoricFormSelected,
  setIsHistoricFormSelected,
  t
}) {
  return (
    <TabPanel value={selectedTab} index={1} className='body__historic'>
      {
        isHistorySelected ?
          <Grid container className={classes.page__form}>
            {!isHistoricFormSelected && <Grid item sm={12} xs={12}>
              <Typography variant='caption'>
                {t('operation_to_register')}
              </Typography>
            </Grid>}
            {!isHistoricFormSelected && <Grid item sm={12} xs={12} className={classes.page__title}>
              <Button
                variant='outlined'
                color='primary'
                onClick={() => setHistorySelected(undefined)}
              >
                <ArrowBackIcon color='primary' className='left_arrow' />
                {t('back')}
              </Button>
            </Grid>}
            <HistoricForm archive={historySelected} setIsHistoricFormSelected={setIsHistoricFormSelected} classes={classes}/>
          </Grid>
          :
          <HistoricItems
            classes={classes}
            archives={archives}
            setHistorySelected={setHistorySelected}
          />
      }
    </TabPanel>
  )
}

export default withTranslation()(TabPanelHistoricContent)